"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createConsultingRequest = require("./createConsultingRequest");
Object.keys(_createConsultingRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createConsultingRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createConsultingRequest[key];
    }
  });
});